import { Injectable } from "@angular/core";
import { chain } from "lodash";
import { ITplArbetsorder, ITplHandelssortiment } from "../models/dtos";

@Injectable({
    providedIn: "root"
})
export class TplCalculator {
    sumHandelssortimentVolym(
        arbetsordrar: ITplArbetsorder[],
        isVaglager: boolean,
        applicableHandelssortimentIdList?: number[],
        applicableMottagningsplatserIdList?: number[]) {
        const hsFilterActive = applicableHandelssortimentIdList?.length > 0;
        const hsFilter = (hs: ITplHandelssortiment): boolean => {
            if (!hsFilterActive) {
                return true;
            }
            return applicableHandelssortimentIdList.includes(hs.handelssortimentId);
        };

        const mplFilterActive = applicableMottagningsplatserIdList?.length > 0;
        const mplFilter = (hs: ITplHandelssortiment): boolean => {
            if (!mplFilterActive) {
                return true;
            }
            return hs.destineringar.some(destinering => applicableMottagningsplatserIdList.includes(destinering.mottagningsplatsId));
        };

        const resolveVolym = (hs: ITplHandelssortiment): number => (isVaglager ? hs.vagVolym : hs.planeradVolym) ?? 0;

        return chain(arbetsordrar)
            .flatMap(x => x.handelssortiment)
            .filter(hsFilter)
            .filter(mplFilter)
            .sumBy(resolveVolym)
            .value();
    }

}
